import { api } from "./api.js";
import { readProject } from "./config.js";

interface ServerRow {
  id: string;
  name: string | null;
  status: string;
}

/**
 * Resolve which agent server to target: --server wins, then a linked project
 * (.clawnify/project.json), then the org's single server. Exits with a clear
 * message when the org has zero or several servers and none was specified.
 * Shared by the `sessions` and `agents` commands.
 */
export async function resolveServerId(explicit: string | undefined): Promise<string> {
  if (explicit) return explicit;
  const linked = readProject()?.server_id;
  if (linked) return linked;

  const res = await api.get("/servers");
  if (!res.ok) {
    console.error("Failed to list servers. Run `clawnify login` and try again.");
    process.exit(1);
  }
  const { servers } = (await res.json()) as { servers: ServerRow[] };
  if (!servers || servers.length === 0) {
    console.error(
      "No agent server in this org yet. Provision one at https://app.clawnify.com.",
    );
    process.exit(1);
  }
  if (servers.length === 1) return servers[0].id;

  console.error(
    "This org has multiple servers — pick one with --server <id> (or run `clawnify servers`):\n",
  );
  for (const s of servers) {
    console.error(`  ${s.id}  ${s.name ?? "(unnamed)"}  [${s.status}]`);
  }
  process.exit(1);
}
